/* eslint-disable camelcase */
import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { Bar, BarItem, Image, BarVertical } from '../../../../components/';
import { isoDateToSlovak, normalizeUrl } from '../utils';
import SinglePostSkeleton, { BlogContainer } from './SinglePostSkeleton';
import './style.scss';
import { fetchPost } from './utils';

const Post = ({ postId }) => {
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    () => {
      const loadPost = async () => {
        setPost(await fetchPost(postId));
      };

      loadPost();
    },
    [postId]
  );

  useEffect(
    () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    [postId]
  );

  if (post === null) {
    return null;
  }

  const {
    excerpt,
    feature_image,
    html,
    primary_author,
    published_at,
    title,
  } = post;

  const { bio, name, profile_image } = primary_author;

  if (!isLoading && window.instgrm) {
    window.instgrm.Embeds.process();
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        {/* Primary Meta Tags */}
        <meta name="description" content={excerpt} />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={excerpt} />
        <meta property="og:image" content={feature_image} />
        {/* Twitter */}
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={excerpt} />
        <meta property="twitter:image" content={feature_image} />
        <script
          src="https://platform.instagram.com/en_US/embeds.js"
          async
          defer
        />
      </Helmet>
      {isLoading && <SinglePostSkeleton />}
      <div className={isLoading ? 'visually-hidden' : ''}>
        <BlogContainer narrow spaceTop="none">
          <h2 className="font-family-clearface blog__heading">{title}</h2>
          <p className="blog__leading-paragraph">{excerpt}</p>
          <Bar space="small" align="middle" className="mb-none">
            <BarItem>
              <Image
                src={normalizeUrl(profile_image)}
                circle
                style={{ width: '48px' }}
                className="mb-none"
                alt={name}
              />
            </BarItem>
            <BarItem>
              <small>
                {name}
                <br />
                {isoDateToSlovak(published_at)}
              </small>
            </BarItem>
          </Bar>
        </BlogContainer>
        <Image
          src={feature_image}
          alt={title}
          onLoad={() => setIsLoading(false)}
          className="cover-image"
        />
        <BlogContainer spaceBottom="none">
          <div
            className="post-content"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </BlogContainer>
        <BlogContainer narrow spaceTop="none" spaceBottom="none">
          <hr />
          <BarVertical align="middle" direction={{ s: 'horizontal' }}>
            <BarItem>
              <Image
                src={normalizeUrl(profile_image)}
                circle
                style={{ width: '99px' }}
                className="mb-none"
                alt={name}
              />
            </BarItem>
            <BarItem canShrink isFilling className="byline">
              <h5 className="blog__author-name">{name}</h5>
              {bio}
            </BarItem>
          </BarVertical>
        </BlogContainer>
      </div>
    </React.Fragment>
  );
};

Post.propTypes = {
  postId: propTypes.string,
};

export default Post;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/SinglePost/index.js